import React, { useCallback, useMemo, useState, useRef, useEffect } from 'react'

import { Report } from '~/components';
import {
  RadioGroup, DateTime, Input
} from '~/components/Form';

import { format, subDays, setHours, setMinutes, setSeconds, parseISO } from 'date-fns';
import { SelectComplete } from '~/componentslocal';
import * as Yup from 'yup';
import { t, parseDateString } from '~/helpers';

import { TypeFilters } from '~/components';
import { isEmpty, isNull } from 'lodash';


export default function DlgRelVazaoNaoAutorizada() {

  const filtroTipos = [];

  const [open, setOpen] = useState(true);
  const reference = useRef(null);

  const filterRef = useRef(null);

  const [post, setPost] = useState('')
  const [dataObjto, setDataObjto] = useState({});




  const [tipoTypeFilters, setTipoTypeFilters] = useState(0)
  const [dataHoraInicial, setDataHoraInicial] = useState('')
  const [dataHoraFinal, setDataHoraFinal] = useState('')

  const [clearField, setClearField] = useState(false);



  const handleGetData = useCallback((value) => {
    setTipoTypeFilters(value.tipo)
    if (value.tipo === 1) {
      setDataHoraInicial(value.datahora_inicio)
      setDataHoraFinal(value.datahora_fim)
    } else if (value.tipo == 5) {

      setDataHoraInicial(value.turno_inicio ? value.turno_inicio.turn_datahora_ini : value.data_inicio_turno + ' 00:00:00')
      setDataHoraFinal(value.turno_fim ? value.turno_fim.turn_datahora_fim : value.data_fim_turno + ' 23:59:59')

    } else if (value.tipo == 2) {
      setDataHoraInicial(value.data_inicio + ' 00:00:00')
      setDataHoraFinal(value.data_fim + ' 23:59:59')
    }
    setDataObjto(value);
  }, [filterRef]);

  const schemaDataHora = Yup.object().shape({
    datahora_inicio: Yup.date()
      .typeError(t('s.geral.validacao.campoobrigatorio'))
      .transform((_, value) => parseDateString(value))
      .required(t('s.geral.validacao.campoobrigatorio')),
    datahora_fim: Yup.date()
      .typeError(t('s.geral.validacao.campoobrigatorio'))
      .transform((_, value) => parseDateString(value))
      .required(t('s.geral.validacao.campoobrigatorio'))
  });

  const schemaOnlyDataTurno = Yup.object().shape({
    data_inicio_turno: Yup.date()
      .typeError('Data inválida')
      .transform((_, value) => parseDateString(value))
      .required(t('s.geral.validacao.campoobrigatorio')),
    data_fim_turno: Yup.date()
      .typeError('Data inválida')
      .transform((_, value) => parseDateString(value))
      .required(t('s.geral.validacao.campoobrigatorio')),
    posto: Yup.string().typeError(t('s.geral.validacao.campoobrigatorio')).required(t('s.geral.validacao.campoobrigatorio'))
  });

  const handleValidate = useCallback(async (data) => {
    try {

      if (tipoTypeFilters == 1) {
        await schemaDataHora.validate({ datahora_inicio: dataHoraInicial, datahora_fim: dataHoraFinal }, {
          abortEarly: false,
        });
      } else if (tipoTypeFilters == 5) {
        await schemaOnlyDataTurno.validate({ data_inicio_turno: dataHoraInicial, data_fim_turno: dataHoraFinal, posto: post.post_cod_posto }, {
          abortEarly: false,
        });
      }
      filterRef.current.setErrors({})

    } catch (err) {
      console.log(err)
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });
        filterRef.current.setErrors(form);

      }
      throw err;
    }
  }, [dataObjto, dataHoraInicial, dataHoraFinal, filterRef, tipoTypeFilters, post])


  const handleSerializeForm = useCallback((param) => {

    return {
      ...param,
      posto: post.post_cod_posto ? post.post_cod_posto : '',
      postostr: post.post_desc ? post.post_desc : '',
      datahorainicial: dataHoraInicial,
      datahorafinal: dataHoraFinal,
      idtarefapath: "dlgRelVazaoNaoAutorizada.swf",
    }

  }, [dataHoraInicial, dataHoraFinal, post])


  const headerFiltro = useMemo(() => [

    filtroTipos.push({ label: t('s.geral.filtro.periododatahora'), value: 1 }),

    (!isNull(post.post_cod_posto)) ?
      filtroTipos.push({ label: t('s.geral.filtro.turno'), value: 5 })
      : '',

  ], [post]);



  return (
    <>
      <Report
        ref={reference}
        open={open}
        onClose={() => setOpen(false)}
        title="Vazão não autorizada"
        relatorio="VAZAONAOAUTORIZADA"
        validate={handleValidate}
        serialize={(param) => handleSerializeForm(param)}
      >

        <SelectComplete
          name="posto"
          title="Posto"
          label="post_desc"
          unique="post_cod_posto"
          url="usuarioposto"
          getValue={(value) => {
            setPost(value);
          }}
        />

        <TypeFilters
          ref={filterRef}
          initials={{
            tipo: 1,
            datahora_inicio: format(setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0), 'dd/MM/yyyy HH:mm:ss'),
            datahora_fim: format(setSeconds(setMinutes(setHours(new Date(), 23), 59), 59), 'dd/MM/yyyy HH:mm:ss')
          }}
          name="filtroData"
          numberOfYears={9}
          options={[
            { label: t('s.geral.filtro.periododatahora'), value: 1 },
            { label: t('s.geral.filtro.turno'), value: 5 },
          ]}
          onCallback={handleGetData}
          initialURL="/turno/getturnosinicio"
          finalURL="/turno/getturnosfim"
          code={post.post_cod_posto}
        />

        <Input name="bico" label="Bico" type="number" />

        <Input name="volume" label="Volume Mínimo" type="number" />

        <RadioGroup
          name="tipo"
          label="Formato"
          options={[
            { label: 'PDF', value: 'pdf' },
            { label: 'Excel', value: 'xls' },
          ]}
          defaultValue="pdf"
          serialize={(value) => value}
          row
        />

      </Report>
    </>

  )
}
